<template>
  <v-app>
    <v-navigation-drawer
      v-if="$vuetify.breakpoint.smAndDown"
      v-model="drawer"
      app
    >
      <v-list dense>
        <v-list-item>
          <v-list-item-content>
            <v-tooltip v-if="loggedInUser !== null" bottom>
              <template v-slot:activator="{ on }">
                <v-btn text v-on="on" @click="logOut" class="text-lowercase secondary">{{loggedInUser.email}}<v-icon class="ml-3">mdi-logout</v-icon></v-btn>
              </template>
              <span>Log out</span>
            </v-tooltip>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content v-if="customersData !== null && customersData.length > 1">
                <v-btn to="home" text class="text-capitalize secondary">Change Customer</v-btn>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      app
      :class="isNaboenTheme ? 'primary' : ''"
      dark
    >
      <div class="d-flex align-center">
        <v-img
          :src="require('./assets/defa-logo-red.svg')"
          class="my-3"
          contain
          width="70"
          height="25"
        />
        <v-toolbar-title v-show="$vuetify.breakpoint.mdAndUp" class=" ml-3 headline text-uppercase">
          <span>Naboen</span>
          <span class="font-weight-light"> Administration</span>
        </v-toolbar-title>
      </div>
      <v-spacer/>
      <v-toolbar-items v-if="loggedInUser !== null">
        <v-app-bar-nav-icon v-show="$vuetify.breakpoint.smAndDown" @click.stop="drawer = !drawer" />
        <v-expansion-panels v-model="customerPanel" v-if="customersData !== null && $vuetify.breakpoint.mdAndUp">
          <v-expansion-panel :class="isNaboenTheme ? 'primary' : ''">
              <v-expansion-panel-header class="currentCustomerHeader">{{ customerListHeader }}</v-expansion-panel-header>
            <v-expansion-panel-content :class="isNaboenTheme ? 'primary' : ''">
              <CustomerList :primaryColor="isNaboenTheme" :dense="true" :on-click-customer="changeCustomer" :customers="customersData"/>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      <v-tooltip v-if="$vuetify.breakpoint.mdAndUp" bottom>
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on" @click="logOut" :class="isNaboenTheme ? 'primary text-lowercase white--text' : 'text-lowercase secondary'">
            {{loggedInUser.email}}
            <v-icon class="ml-3">mdi-logout</v-icon></v-btn>
        </template>
        <span>Log out</span>
      </v-tooltip>
      </v-toolbar-items>
    </v-app-bar>

    <v-content>
      <SuccessSnackBar v-if="successMessage" :message="successMessage" :timeout="6000"/>
      <ErrorModal/>
      <v-row justify="center" no-gutters>
        <v-col cols="12">
        <router-view/>
        </v-col>
      </v-row>
    </v-content>
  </v-app>
</template>

<script>
import CustomerList from './components/CustomerList'
import SuccessSnackBar from './components/SuccessSnackBar'
import ErrorModal from './components/ErrorModal'
import customerName from './mixins/customerName'

export default {
  name: 'App',
  mixins: [customerName],
  components: {
    CustomerList,
    SuccessSnackBar,
    ErrorModal
  },

  data: () => ({
    isNaboenTheme: false,
    customerPanel: false,
    drawer: null
  }),

  created () {
    let domain = document.domain
    let domainRegex = /^naboen(\.(\w)+)?\.mydefa\.com$/i
    if (domainRegex.test(domain)) {
      // Light theme
      this.isNaboenTheme = true
      this.$vuetify.theme.themes.light.primary = '#ee7925'
      // Dark theme
      this.$vuetify.theme.themes.dark.primary = '#ee7925'
    }
  },

  methods: {
    logOut: function () {
      let self = this
      this.$store.dispatch('logOut').then(function () {
        self.$router.push({ name: 'login' })
      })
    },
    changeCustomer: function (customerData) {
      if (this.currentCustomer === null || customerData.id !== this.currentCustomer.id) {
        this.$store.commit('customer/setCurrentCustomer', { data: customerData, error: null })
        this.$router.push({ name: 'customer', params: { customerId: customerData.id } })
        this.customerPanel = undefined
      }
    }
  },

  computed: {
    loggedInUser: function () {
      return this.$store.state.loggedInUser
    },
    customersData: function () {
      return this.$store.state.customers.data
    },
    currentCustomer: function () {
      return this.$store.state.customer.currentCustomer.data
    },
    successMessage: function () {
      return this.$store.state.successMessage
    },
    customerListHeader: function () {
      return this.$store.state.customer.currentCustomer.data === null ? 'Select a customer' : this.getCustomerName(this.$store.state.customer.currentCustomer.data)
    }
  },

  watch: {
    currentCustomer: function (newValue, oldValue) {
      if (newValue !== null && oldValue === null) {
        this.$store.dispatch('customer/fetchAllSubscriptions')
        this.$store.dispatch('customer/fetchAllUsersWithSubscription')
        this.$store.dispatch('customer/fetchAllInvitations')
        this.$store.dispatch('customer/startPollInvitations')
        this.$store.dispatch('customer/startPollUsers')
      }
      if ((newValue !== null && oldValue !== null) && (newValue.id !== oldValue.id)) {
        if (this.$route.name !== 'customer') {
          this.$router.push({ name: 'customer', params: { customerId: this.currentCustomer.id } })
        }
        this.$store.dispatch('customer/resetCurrentCustomerData')
        this.$store.dispatch('customer/fetchAllSubscriptions')
        this.$store.dispatch('customer/fetchAllUsersWithSubscription')
        this.$store.dispatch('customer/fetchAllInvitations')
        this.$store.dispatch('customer/startPollInvitations')
        this.$store.dispatch('customer/startPollUsers')
      }
    }
  }
}
</script>
<style scoped lang="scss">
  .currentCustomerHeader {
    padding-bottom:  0;
  }
  .v-expansion-panel:before {
    box-shadow: none !important;
  }
</style>
